import React, {useState} from "react";
import {useAvailableLongtermHippodromes} from "features/bulletin/bulletin.store";
import {dateFormat} from "../../../services/misc.functions";
import lockIcon from "../../../assets/feather/lock.svg";
import "../fob.betting/fob-betting.css";
import {LongtermBetslip, useLongtermBetslip} from "features/betslip/longterm.service";
import {NewLongtermBetslip, NewLongtermMobileBetslipBar} from "./new.longterm.betslip";
import {isMobile} from "../../../App";
import Draggable from "react-draggable";
import blackHorse from "../../../assets/img/siyahat.png";

function LongtermHeader({hippodrome}: any) {
    return (
        <div className={"d-flex justify-content-between align-items-center flex-wrap fob-header"}>
            <div className="d-flex flex-column">
                <h5 className="card-title mb-0">{hippodrome.hippodrome}</h5>
                <div className="fw-light">{hippodrome.description}</div>
            </div>
            <div className="d-flex flex-column">
                <span className="fs-6">Kapanış: {dateFormat(hippodrome._date)}</span>
            </div>
        </div>
    );
}

function LongtermBody({hippodrome}: any) {
    return (
        <div className="card run-card mb-2">
            <div className="row">
                {Object.entries(hippodrome.event_odds).map(([no, odd]: any) => {
                    const isAddedHorse = LongtermBetslip.isAdded(hippodrome, odd);
                    return (
                        <div className={"col-6 col-md-3"} key={`longterm-horse-${hippodrome._id}-${no}`}>
                            <div className={"d-flex flex-column gap-4 border border-primary rounded-3 p-3 m-3 text-center"}>
                                <div>
                                    <span className="fw-bold fs-6">{odd.description}</span>
                                </div>
                                <div className={"odd-button cursor-pointer" + (isAddedHorse ? " selected" : "")}
                                     onClick={() => LongtermBetslip.toggle(hippodrome, odd)}>
                                    {odd.status === "o" ? Number(odd.win_odds).toFixed(2) :
                                        <img width={18} src={lockIcon} alt="kapalı"/>}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export function LongtermBetting() {
    const longtermHippodromes = useAvailableLongtermHippodromes();

    const selection = useLongtermBetslip();
    const [isDesktopSlipOpen, setIsDesktopSlipOpen] = useState(false);
    const [isMobileSlipOpen, setIsMobileSlipOpen] = useState(false);

    if (longtermHippodromes.length === 0) {
        return (
            <div className={"col-12"} style={{minHeight: "50vh"}}>
                <div className={"page-widget"}>
                    <div className="hint-text text-center p-3">
                        <p className={"fs-6 mb-0"}>Uzun Vadeli bahis türünde açık hipodrom bulunmamaktadır.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={"row"}>
            {!(isMobile && isMobileSlipOpen) && longtermHippodromes.map((hippodrome: any, index: number) => (
                <div className={"fob-card"} key={`longterm-hippodrome-${hippodrome._id || index}`}>
                    <LongtermHeader hippodrome={hippodrome}></LongtermHeader>
                    <LongtermBody hippodrome={hippodrome}></LongtermBody>
                </div>
            ))}

            {!isMobile && isDesktopSlipOpen && (
                <Draggable>
                    <div className={"longterm-betslip"}>
                        <NewLongtermBetslip onClose={() => setIsDesktopSlipOpen(false)}/>
                    </div>
                </Draggable>
            )}

            {!isMobile && !isDesktopSlipOpen && (
                <div
                    onClick={() => {
                        setIsDesktopSlipOpen(true);
                    }}
                    className={"fob-toggle py-1"}
                >
                    <div className="d-flex align-items-center justify-content-start ">
                        <span className={`fob-toggle-icon`}>
                            <span className="horse-amount">{selection ? 1 : 0}</span>
                            <img src={blackHorse} alt=""/>
                            <span className="up-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    fill="currentColor"
                                    className="bi bi-caret-up"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659"/>
                                </svg>
                            </span>
                        </span>
                        <div className="d-block justify-content-start ms-0">
                            <span className="fw-light">Oran:</span>
                            <span className="nowrap">{selection ? Number(selection.horse.win_odds).toFixed(2) : "-"}</span>
                        </div>
                    </div>
                </div>
            )}

            {isMobile && !isMobileSlipOpen && (
                <NewLongtermMobileBetslipBar onOpen={() => setIsMobileSlipOpen(true)}/>
            )}

            {isMobile && isMobileSlipOpen && (
                <div className="col-betslip">
                    <NewLongtermBetslip onClose={() => setIsMobileSlipOpen(false)}/>
                </div>
            )}
        </div>
    );
}
